"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("./scss/main.scss");
const react_router_dom_1 = require("react-router-dom");
const ErrorBoundary_1 = __importDefault(require("./components/common/ErrorBoundary"));
const ProfileView_1 = __importDefault(require("./components/ProfileView"));
const PeopleStore_1 = require("./model/PeopleStore");
const hui_1 = require("@mit/hui");
const mobx_react_1 = require("mobx-react");
const UserProfileStore_1 = __importDefault(require("./model/UserProfileStore"));
const CovidNav_1 = require("./model/CovidNav");
const MedicalApi_1 = __importDefault(require("./api/MedicalApi"));
const Home_1 = __importDefault(require("./Home"));
const ReleaseNotes_1 = __importDefault(require("./components/release-notes/ReleaseNotes"));
const Roles_1 = __importDefault(require("./model/Roles"));
require("react-toastify/dist/ReactToastify.css");
const react_toastify_1 = require("react-toastify");
const AppStore_1 = __importDefault(require("./model/AppStore"));
const App = () => {
    var _a;
    // const [userProfileStoreState, setUserProfileStoreState] = useState<UserProfileStore | undefined>(undefined);
    // const [pageError, setPageError] = useState<PageError>({ error: false, errorText: "" });
    // const [isLoading, setIsLoading] = useState<boolean>(true);
    const [title, setTitle] = (0, react_1.useState)("Follow-up Required");
    const [showReleaseNotes, setShowReleaseNotes] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => { }, [CovidNav_1.covidNav.activePage]);
    const navData = [
        {
            icon: "exclamation-triangle",
            text: "Active Cases",
            iconOnly: false,
            to: "contact-tracing",
            onClick: () => {
                setTitle("Active Cases");
                CovidNav_1.covidNav.activePage = "contact-tracing";
            },
            overrideState: (item) => {
                return window.location.pathname === "/contact-tracing" ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        },
        {
            icon: "phone-laptop",
            text: "Search",
            iconOnly: false,
            to: "search",
            onClick: () => {
                setTitle("Search");
                CovidNav_1.covidNav.activePage = "search";
            },
            overrideState: (item) => {
                return CovidNav_1.covidNav.activePage === "search" && window.location.pathname.includes("/search") ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        },
        {
            icon: "users",
            text: "Follow-up Required",
            iconOnly: false,
            to: "/follow-up",
            onClick: () => {
                setTitle("Follow-up Required");
                CovidNav_1.covidNav.activePage = "follow-up";
            },
            overrideState: (item) => {
                return (CovidNav_1.covidNav.activePage === "follow-up" && window.location.pathname.includes("/follow-up")) || window.location.pathname == "/" ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        },
        {
            icon: "check-circle",
            text: "Completed Tests",
            iconOnly: false,
            to: "completed-tests",
            onClick: () => {
                setTitle("Completed Tests");
                CovidNav_1.covidNav.activePage = "completed-tests";
            },
            overrideState: (item) => {
                return CovidNav_1.covidNav.activePage === "completed-tests" && window.location.pathname.includes("/completed-tests") ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        },
        {
            icon: "syringe",
            text: "Flu Shots",
            iconOnly: false,
            to: "flushots",
            onClick: () => {
                setTitle("Flu Shots");
                CovidNav_1.covidNav.activePage = "flushots";
            },
            overrideState: (item) => {
                return CovidNav_1.covidNav.activePage === "flushots" && window.location.pathname === "/flushots" ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        },
    ];
    CovidNav_1.covidNav &&
        CovidNav_1.covidNav.features &&
        CovidNav_1.covidNav.features["covid19.medical.vaccine.visible"] &&
        navData.push({
            icon: "shield-check",
            text: "Covid Vaccine",
            iconOnly: false,
            to: "vaccine",
            onClick: () => {
                setTitle("Covid Vaccine");
                CovidNav_1.covidNav.activePage = "vaccine";
            },
            overrideState: (item) => {
                return CovidNav_1.covidNav.activePage === "vaccine" && window.location.pathname === "/vaccine" ? hui_1.NavItemState.Active : hui_1.NavItemState.None;
            },
        });
    (0, react_1.useEffect)(() => {
        document.documentElement.lang = "eng";
        // Prevent form submission on enter key press inside inputs
        const listener = (e) => {
            if (e.keyIdentifier === "U+000A" || e.keyIdentifier === "Enter" || e.keyCode === 13) {
                if (e.target.nodeName === "INPUT") {
                    e.preventDefault();
                    return false;
                }
            }
        };
        document.addEventListener("keydown", listener, true);
        // const featurePromise = userController.fetchFeatures();
        // const profilePromise = userController.fetchProfile();
        // const statusesPromise = medicalApi.fetchHoldStatuses();
        // const vacineHoldStatusesPromise = medicalApi.fetchVaccineHoldStatuses();
        // const textsPromise = medicalApi.fetchTexts();
        // const contactTracingStatusPromise = contactTracingApi.fetchStatus();
        // const rolesPromise = contactTracingApi.fetchRoles();
        // const exemptionTypesPromise = medicalApi.fetchExemptionTypes();
        // const featuresPromise = featureController.fetchFeatures();
        // const textPromise = dataController.fetchArray('texts')
        // Promise.all([featurePromise, profilePromise, statusesPromise, textsPromise, rolesPromise, vacineHoldStatusesPromise, contactTracingStatusPromise, exemptionTypesPromise, featuresPromise, textPromise])
        // 	.then(([featureResponse, profileResponse, statusesResponse, textsResponse, rolesResponse, vacineStatusesResponse, contactTracingStatusResponse, exemptionTypesResponse, featuresResponse, textResponse]) => {
        // 		if (contactTracingStatusResponse.items) {
        // 			covidNav.contactTracingStatus = contactTracingStatusResponse.items;
        // 		}
        // 		if (textsResponse.items) {
        // 			let texts = textsResponse.items.reduce((all: any, current: TextItem) => {
        // 				return {
        // 					...all,
        // 					[current.id]: current.text,
        // 				};
        // 			}, {});
        // 			covidNav.texts = texts;
        // 		}
        // 		let permissions = featureResponse.reduce((obj: any, curr: any) => {
        // 			return { ...obj, [curr.id]: curr.value };
        // 		}, {});
        // 		//@ts-ignore
        // 		vaccineHolds.statuses = vacineStatusesResponse.items;
        // 		holds.exemptionTypes = exemptionTypesResponse;
        // 		//@ts-ignore
        // 		holds.statuses = statusesResponse.items;
        // 		roles.roles = rolesResponse.items;
        // 		holds.features = featuresResponse.data?.features
        // 		holds.appText = textResponse.items
        // 		covidNav.features = permissions;
        // 		if (rolesResponse.items.length > 0) {
        // 			if (profileResponse.person) {
        // 				setUserProfileStoreState(
        // 					new UserProfileStore({
        // 						kerberosId: profileResponse.person.kerberosId,
        // 						firstName: profileResponse.person.firstName,
        // 						lastName: profileResponse.person.lastName,
        // 						displayName: profileResponse.person.displayName,
        // 					})
        // 				);
        // 			}
        // 		} else {
        // 			setPageError({ error: true, errorText: `You are not authorized for this application. For more information, please contact ${CONTACT_SUPPORT_LINK}.` });
        // 		}
        // 		// setFeatures(featuresResponse)
        // 		setIsLoading(false);
        // 	})
        // 	.catch((error) => {
        // 		setPageError({ error: true, errorText: `An error occurred and the application could not be loaded. If the problem persists, please contact ${CONTACT_SUPPORT_LINK}.` });
        // 		setIsLoading(false);
        // 	});
    }, []);
    const refreshPage = () => {
        if (CovidNav_1.covidNav.activePage === "follow-up") {
            reloadDataFollowUp();
        }
        if (CovidNav_1.covidNav.activePage === "vaccine-hold") {
            reloadDataVaccineHold();
        }
        if (CovidNav_1.covidNav.activePage === "completed-tests") {
            reloadDataCompleted();
        }
        if (CovidNav_1.covidNav.activePage === "flushots") {
            reloadDataFluShots();
        }
        if (CovidNav_1.covidNav.activePage === "vaccine") {
            reloadDataVaccine();
        }
        if (CovidNav_1.covidNav.activePage === "search") {
            window.location.reload();
        }
        if (CovidNav_1.covidNav.activePage === "contact-tracing") {
            reloadDataContactTracing();
        }
    };
    const reloadDataFollowUp = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const followUpResponse = yield MedicalApi_1.default.fetchAllHolds();
        if (followUpResponse.error) {
            //todo: handle error
        }
        else {
            if (followUpResponse.items) {
                PeopleStore_1.peopleStore.setFollowUpList(followUpResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataVaccineHold = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const followUpResponse = yield MedicalApi_1.default.fetchAllVaccineHolds();
        if (followUpResponse.error) {
            //todo: handle error
        }
        else {
            if (followUpResponse.items) {
                PeopleStore_1.peopleStore.setVaccineHoldList(followUpResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataCompleted = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const resultsResponse = yield MedicalApi_1.default.fetchPersonResults(CovidNav_1.covidNav.currentDateString);
        if (resultsResponse.error) {
            //todo: handle error
        }
        else {
            if (resultsResponse.items) {
                PeopleStore_1.peopleStore.setCompletedList(resultsResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataFluShots = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        const fluShotDetailResponse = yield MedicalApi_1.default.fetchFluShotResults(CovidNav_1.covidNav.currentDateString);
        if (fluShotDetailResponse.error) {
            //todo: handle error
        }
        else {
            if (fluShotDetailResponse.items) {
                PeopleStore_1.peopleStore.setFluShotList(fluShotDetailResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataVaccine = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        CovidNav_1.covidNav.currentDateString = "";
        const vaccineDetailResponse = yield MedicalApi_1.default.fetchVaccineResults(CovidNav_1.covidNav.currentDateString);
        if (vaccineDetailResponse.error) {
            //todo: handle error
        }
        else {
            if (vaccineDetailResponse.items) {
                PeopleStore_1.peopleStore.setVaccineList(vaccineDetailResponse.items);
                CovidNav_1.covidNav.globalTableIsLoading = false;
            }
        }
    });
    const reloadDataContactTracing = () => __awaiter(void 0, void 0, void 0, function* () {
        CovidNav_1.covidNav.globalTableIsLoading = true;
        PeopleStore_1.peopleStore.setContactTracingList([]);
    });
    const handleShowReleaseNotes = () => {
        setShowReleaseNotes(true);
    };
    const handleReleaseNotesClose = () => {
        setShowReleaseNotes(false);
    };
    const utilityNavData = [
        {
            icon: "question-square",
            text: "Help",
            iconOnly: false,
            onClick: () => {
                window.open("mailto:covidapps-help@mit.edu");
            },
        },
        {
            icon: "calendar",
            text: "Time Management",
            overrideState: (item) => {
                return hui_1.NavItemState.None;
            },
            onClick: () => {
                setTitle("Time Management");
            },
            to: "time-management",
            state: ((_a = Roles_1.default === null || Roles_1.default === void 0 ? void 0 : Roles_1.default.roles) === null || _a === void 0 ? void 0 : _a.includes("medical")) ? hui_1.NavItemState.None : hui_1.NavItemState.Invisible,
            iconOnly: false,
        },
        { icon: "bell", text: "What's new", onClick: handleShowReleaseNotes, iconOnly: false },
        { icon: "sync", text: `Reload ${title}`, iconOnly: false, onClick: refreshPage },
    ];
    const getEnv = () => {
        if (process.env.ENV === "prod")
            return "production";
        if (process.env.ENV === "test" || process.env.ENV === "release")
            return "staging";
        if (process.env.ENV === "dev" || process.env.ENV === "develop")
            return "dev";
        if (process.env.ENV === "local")
            return "dev";
        return "production";
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { position: "top-right", autoClose: 5000, hideProgressBar: false, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true }), AppStore_1.default.pageError.error && (0, jsx_runtime_1.jsx)(hui_1.Error, { context: hui_1.ErrorContext.Page, type: hui_1.ErrorType.AccessDenied, message: AppStore_1.default.pageError.errorText }), !AppStore_1.default.isLoading && !AppStore_1.default.pageError.error && ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ErrorBoundary_1.default, Object.assign({ errorComponent: (0, jsx_runtime_1.jsx)(hui_1.Error, { message: "Something went wrong.", type: hui_1.ErrorType.Generic, context: hui_1.ErrorContext.Page }) }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsx)(hui_1.AtlasPage, { name: "COVID Medical", contentAriaLabel: "COVID Medical Content Container.", environment: getEnv(), utilityNavigation: utilityNavData, subtitle: "Testing and Admin Console", theme: "medical", utilMaxWidth: 1440, utilMinWidth: 1441, gaId: "G-XG7JEHXLVC", profile: (0, jsx_runtime_1.jsx)(ProfileView_1.default, { userProfileStore: UserProfileStore_1.default }), navigation: (0, jsx_runtime_1.jsx)(hui_1.NavBar, { responsiveType: hui_1.ResponsiveTypes.CollapseSome, type: hui_1.NavBarTypes.IconText, tabs: navData }), content: (0, jsx_runtime_1.jsx)(Home_1.default, {}) }) }) })), (0, jsx_runtime_1.jsx)(ReleaseNotes_1.default, { show: showReleaseNotes, onClose: handleReleaseNotesClose })] }))] }));
};
const AppWrapper = (0, mobx_react_1.inject)("peopleStore", "holds", "covidNav")((0, mobx_react_1.observer)(App));
exports.default = AppWrapper;
